import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faBan, faSave, faTrashAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'

function RoleUserCard(props) {

    const update = (e) => {
        console.log('updating role user...');
        props.update(props.userRole, e);
    };

    const cancel = () => {
        console.log('Canceling role user...');
        props.cancel(props.userRole.roleID, props.userRole.userID);
    };

    const save = () => {
        console.log('Saving role user...');
        props.save(props.userRole);
    };

    const roleUserJSX = (
        <div className="role-user card  item-details">
            <div className="properties">
                <InputGroup className="tooltip-parent">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText><i className="fas fa-envelope"></i></InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Email" name="emailAddress" value={props.userRole.emailAddress || ''} onChange={update} list="emailSearchList" />
                    <datalist id="emailSearchList">
                        {props.users.map(u => (<option key={u.userID} value={u.emailAddress}>{u.emailAddress}</option>))}
                    </datalist>
                    <div className="tooltip-target">
                        User Email
                    </div>
                </InputGroup>
            </div>
            <div className="actions-horizontal">
                <div onClick={cancel} className="action-icon action-delete">
                    <FontAwesomeIcon icon={faBan} />
                </div>
                <div onClick={save} className="action-icon action-add">
                    <FontAwesomeIcon icon={faSave} />
                </div>
            </div>
        </div>
    );

    return roleUserJSX;
}

export default RoleUserCard;